import { ChangeDetectionStrategy, Component, HostBinding, Input, output, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckboxChangeEvent, CheckboxModule } from 'primeng/checkbox';
import { CoreControlDirective } from '../../utils/core-control.directive';

@Component({
  selector: 'osp-checkbox',
  standalone: true,
  imports: [CheckboxModule, ReactiveFormsModule],
  providers: CoreControlDirective.coreControlProvider(CheckboxComponent),
  templateUrl: './checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent extends CoreControlDirective {
  @HostBinding('class.osp-checkbox') protected hostCssClassEnabled = true;

  @Input() binary: boolean = true;
  @Input() label: string | undefined;
  @Input() name: string | undefined;
  @Input() tabindex: number | undefined;
  @Input() inputId: string | undefined;
  @Input() styleClass: string | undefined;
  @Input() labelStyleClass: string | undefined;
  @Input() ariaLabel: string | undefined;
  @Input() ariaLabelledBy: string | undefined;
  @Input() ariaChecked: boolean | undefined;
  @Input() ariaDisabled: boolean | undefined;
  @Input() ariaRequired: boolean | undefined;
  @Input() ariaInvalid: boolean | undefined;
  @Input() ariaDescribedBy: string | undefined;
  @Input() ariaControls: string | undefined;
  @Input() ariaRole: string | undefined;
  @Input() readonly = false;
  @Input() $isRequired = signal(false);

  $onChange = output<CheckboxChangeEvent>({ alias: 'onChange' });
}
